"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateVibrationState = exports.getEndTime = exports.convertToMarginLink = exports.VALVE_VIBRATION_HISTORY_LENGTH = void 0;
exports.updateEntity = updateEntity;
const tslib_1 = require("tslib");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const datamodel_core_1 = require("@iotv/datamodel-core");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
exports.VALVE_VIBRATION_HISTORY_LENGTH = 7;
const sfToSensitivityMap = {
    6: -121,
    7: -124,
    8: -127,
    9: -130,
    10: -133,
    11: -136,
    12: -139,
};
const convertToMarginLink = (sf, snr, rssi) => {
    var _a;
    if (sf !== undefined && snr !== undefined && rssi !== undefined) {
        let first = 10 * Math.log10(Math.pow(10, rssi / 10) - Math.pow(10, rssi / 10) / (1 + Math.pow(10, snr / 10)));
        let second = (_a = sfToSensitivityMap[sf]) !== null && _a !== void 0 ? _a : 0;
        return Math.max(Math.floor(first - second), 0);
    }
};
exports.convertToMarginLink = convertToMarginLink;
/**
 * @function updateEntity is bound to Irrigator Class instance in constructor
 * @param payload
 */
function updateEntity(payload) {
    var _a, _b, _c, _d, _e;
    // console.log('payload', payload)
    const { battery, error, firmwareVersion, margin, moisture, octants, status, sysTime, temperature, meta, scheduleReport } = payload;
    const { accelerometerThreshold, buttonTime, pulsesOn, pulsesOff, boostVoltage, rtcAdjustment } = payload;
    const { deviceEui, customerDeviceId, sf, rssi, snr, gatewayEui, timestamp, currentTimestamp = Date.now() } = meta !== null && meta !== void 0 ? meta : {};
    this.deviceBatteryVoltage = battery !== null && battery !== void 0 ? battery : this.deviceBatteryVoltage; // inherited
    this.accelerometerThreshold = (_a = accelerometerThreshold !== null && accelerometerThreshold !== void 0 ? accelerometerThreshold : this.accelerometerThreshold) !== null && _a !== void 0 ? _a : undefined;
    this.error = error !== null && error !== void 0 ? error : this.error;
    this.firmwareVersion = firmwareVersion !== null && firmwareVersion !== void 0 ? firmwareVersion : this.firmwareVersion;
    this.margin = margin !== undefined ? margin : this.margin;
    this.moisture = moisture !== undefined ? moisture : this.moisture;
    this.octants = octants !== null && octants !== void 0 ? octants : this.octants;
    this.status = status !== null && status !== void 0 ? status : this.status;
    this.sysTime = sysTime !== null && sysTime !== void 0 ? sysTime : this.sysTime;
    this.temperature = temperature !== null && temperature !== void 0 ? temperature : this.temperature;
    this.config = (_b = scheduleReport === null || scheduleReport === void 0 ? void 0 : scheduleReport.config) !== null && _b !== void 0 ? _b : this.config; // config of sequential
    this.rollingPatternConfig = (_c = scheduleReport === null || scheduleReport === void 0 ? void 0 : scheduleReport.rollingPatternConfig) !== null && _c !== void 0 ? _c : this.rollingPatternConfig;
    this.buttonTime = buttonTime !== null && buttonTime !== void 0 ? buttonTime : this.buttonTime;
    this.pulsesOn = pulsesOn !== null && pulsesOn !== void 0 ? pulsesOn : this.pulsesOn;
    this.pulsesOff = pulsesOff !== null && pulsesOff !== void 0 ? pulsesOff : this.pulsesOff;
    this.solenoidVoltage = boostVoltage !== null && boostVoltage !== void 0 ? boostVoltage : this.solenoidVoltage;
    if (boostVoltage && deviceEui) {
        // if has boost voltage, update the solenoid voltage eui that reported it
        this.solenoidVoltageEUI = deviceEui;
    }
    this.rtcAdjustment = rtcAdjustment !== null && rtcAdjustment !== void 0 ? rtcAdjustment : this.rtcAdjustment;
    const { accelerometerActive, activePattern, downlinkAck, rebooted, sprinklerStatus } = status !== null && status !== void 0 ? status : {};
    let currentTime = currentTimestamp;
    this.accelerometerActive = accelerometerActive;
    this.updated_at = currentTime;
    this.timestamp = currentTime;
    if (this.operating && sprinklerStatus === iotv_v3_types_1.onOff.OFF) {
        this.lastActive = currentTimestamp; // in seconds
    }
    this.irrigating = sprinklerStatus === iotv_v3_types_1.onOff.ON;
    this.activePattern = activePattern !== undefined ? activePattern : this.activePattern;
    const latestOperating = sprinklerStatus !== undefined ? sprinklerStatus === iotv_v3_types_1.onOff.ON : this.operating;
    if (this.vibration && this.activePattern && this.operating && latestOperating) {
        let updatedVibrationHistory = [...((_d = this.vibrationHistory) !== null && _d !== void 0 ? _d : [])];
        let localVibe = { state: accelerometerActive === 1, timestamp: Date.now() };
        updatedVibrationHistory.push(localVibe);
        // updatedVibrationHistory.push(accelerometerActive === 1) // convert 0|1 to false|true
        updatedVibrationHistory = updatedVibrationHistory.slice(-exports.VALVE_VIBRATION_HISTORY_LENGTH);
        this.vibrationHistory = updatedVibrationHistory;
    }
    this.operating = latestOperating;
    if (meta) {
        const { deviceEui, customerDeviceId, sf, rssi, snr, gatewayEui } = meta;
        const nowTime = Date.now();
        if (timestamp) {
            const compDiff = Math.abs(timestamp - nowTime) / 1000;
            if (compDiff > 20) {
                currentTime = nowTime;
            }
        }
        this.deviceEui = deviceEui !== null && deviceEui !== void 0 ? deviceEui : this.deviceEui;
        this.customerDeviceId = customerDeviceId !== null && customerDeviceId !== void 0 ? customerDeviceId : this.customerDeviceId;
        this.sf = sf !== null && sf !== void 0 ? sf : this.sf;
        this.rssi = rssi !== null && rssi !== void 0 ? rssi : this.rssi;
        this.snr = snr !== null && snr !== void 0 ? snr : this.snr;
        this.gatewayEui = gatewayEui !== null && gatewayEui !== void 0 ? gatewayEui : this.gatewayEui;
        this.linkMargin = (_e = (0, exports.convertToMarginLink)(this.sf, this.snr, this.rssi)) !== null && _e !== void 0 ? _e : this.linkMargin;
    }
}
const getEndTime = (start = '00:00', duration, showAP = false) => {
    const endTime = (0, datamodel_core_1.getModifedTime)(start, duration, 'add').format(showAP ? 'hh:mm A' : 'HH:mm');
    return endTime;
};
exports.getEndTime = getEndTime;
const calculateVibrationState = (valveEntity) => {
    var _a;
    let vibrationStatus = 'Not Enabled';
    if (valveEntity.vibration) {
        if (((_a = valveEntity === null || valveEntity === void 0 ? void 0 : valveEntity.vibrationHistory) === null || _a === void 0 ? void 0 : _a.length) === exports.VALVE_VIBRATION_HISTORY_LENGTH) {
            const fails = valveEntity.vibrationHistory.filter((hist) => !hist.state);
            const failsLength = fails.length;
            if (failsLength > exports.VALVE_VIBRATION_HISTORY_LENGTH / 2) {
                vibrationStatus = 'Low Impact';
                let latestTime = fails[fails.length - 1].timestamp;
                let dateTime = (0, dayjs_1.default)(latestTime).format('DD/MM hh:mm A');
                vibrationStatus += ` (${dateTime})`;
            }
        }
        else {
            vibrationStatus = 'Normal';
        }
    }
    return vibrationStatus;
};
exports.calculateVibrationState = calculateVibrationState;
